import { StubTabBody, StubTabRow } from "./_StubTab";

export function StreamTab(): JSX.Element {
  return (
    <StubTabBody summary="Stream-day operator surface. Mirrors the overlay state and lets the streamer fire triggers without a second machine.">
      <StubTabRow
        label="overlay state mirror"
        hint="Show the same pot / king / time-left / last-tx the overlay shows, so the streamer can confirm what viewers see."
      />
      <StubTabRow
        label="fire chat-quorum trigger manually"
        hint="Force the round-start trigger to fire as if the chat-quorum threshold was reached. Useful for dress rehearsals."
      />
      <StubTabRow
        label="round metronome on/off"
        hint="Toggle the scheduled-round timer so off-hours streaming doesn't auto-fire empty rounds."
      />
      <StubTabRow
        label="emergency pause"
        hint="Stop accepting touches without restarting the program. Reversible. For live-stream incident response only."
      />
    </StubTabBody>
  );
}
